import React from "react";
import cs from "classnames";
import styles from "./styles.module.scss";
import { KeywordChipProps } from "./types";
import { PlusCircleIcon, CheckCircleIcon, CloseIcon } from "./icons";

/**
 * Keyword chip (Figma 560:131979). Dumb component — the visual variant is set
 * by `state`. `type`/`typing` render an inline text input instead of a label.
 */
export const KeywordChip: React.FC<KeywordChipProps> = ({
  label,
  state = "default",
  variant = "filled",
  onAdd,
  onRemove,
  value,
  placeholder = "keyword",
  onChange,
  onSubmit,
  className,
}) => {
  const isInput = state === "type" || state === "typing";
  const outlined = variant === "outlined";

  if (isInput) {
    return (
      <span className={cs(styles.chip, styles.input, className)}>
        <input
          className={styles.field}
          value={value ?? ""}
          placeholder={placeholder}
          onChange={(e) => onChange?.(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") onSubmit?.((e.target as HTMLInputElement).value);
          }}
        />
      </span>
    );
  }

  return (
    <span
      className={cs(
        styles.chip,
        styles[`state-${state}`],
        outlined && styles.outlined,
        className,
      )}
    >
      <span className={styles.label}>{label}</span>
      {state === "ready-to-add" && (
        <button
          type="button"
          className={styles.control}
          onClick={(e) => {
            e.stopPropagation();
            onAdd?.();
          }}
          aria-label="Add keyword"
        >
          <PlusCircleIcon />
        </button>
      )}
      {state === "added" && (
        <span className={styles.control} aria-hidden>
          <CheckCircleIcon />
        </span>
      )}
      {(state === "removable" || state === "error") && (
        <button
          type="button"
          className={styles.control}
          onClick={(e) => {
            e.stopPropagation();
            onRemove?.();
          }}
          aria-label="Remove keyword"
        >
          <CloseIcon />
        </button>
      )}
    </span>
  );
};

export default KeywordChip;
